import React, { Component } from 'react'
import { DraggableContainer } from './styledComponents';
import Icon from '../Icon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { colors } from 'globalStyles';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default class DraggableList extends Component {
  state = {
    selected: []
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.props.data,
      result.source.index,
      result.destination.index
    );

    this.listChanged(items);
  }

  onDeleteItem = (item) => {
    const { data } = this.props;

    this.listChanged(data.filter(x => x !== item))
  }

  onToggleSelect = (item) => {
    var list = this.state.selected.find(x => x === item) ? [] : [item];

    this.setState({ selected: list }, () => {
      const { listSelectChanged } = this.props;
      listSelectChanged && listSelectChanged(list.filter(x => !Array.isArray(x)));
    })
  }

  listChanged = (list) => {
    const { listChanged } = this.props;
    listChanged && listChanged(list.filter(x => !Array.isArray(x)));
  }

  componentDidMount() {
    this.setState({ data: this.props.data })
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    try {
      if ((data && !prevProps.data) || (data && prevProps.data.length !== data.length) || (data && JSON.stringify(prevProps.data) !== JSON.stringify(data))) {
        this.setState({ selected: [data[0]] })
      }
    } catch (error) {
      //ignore
    }
  }

  getValueStr = (path) => {
    var isImagePath = path && (path.includes("png") || path.includes("jpg"));
    var result = isImagePath ? path.replace(/\?.*/g, "") : path;
    var pathSplits = result ? result.split('/') : [];

    return isImagePath && pathSplits ? pathSplits[pathSplits.length-1] : path;
  }

  render() {
    const { className, data } = this.props;
    const { selected } = this.state;

    return data && data.filter(x => x && x !== null).length > 0 && Array.isArray(data) ? (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <DraggableContainer dataCount={data ? data.filter(x => !Array.isArray(x) && x !== null).length : null}>
              <ul className={className}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {data.map((item, idx) => {
                  
                  return !Array.isArray(item) && item !== null && (
                  <Draggable key={idx} draggableId={idx} index={idx}>
                    {(childProvided, snapshot) => (
                      <li
                        ref={childProvided.innerRef}
                        {...childProvided.draggableProps}
                        {...childProvided.dragHandleProps}
                        onClick={() => this.onToggleSelect(item)}
                      >
                        <div className='left'>
                          <Icon size='16' name='image' fill={selected.find(x => x === item) && colors.GREEN} />
                          <div className='value'>{this.getValueStr(item)}</div>
                        </div>
                        <div
                          className='right-action'
                          onClick={_e => this.onDeleteItem(item)}>
                          <Icon name='x' size='10' />
                        </div>
                      </li>
                    )}
                  </Draggable>
                )})}
                {provided.placeholder}
              </ul>
            </DraggableContainer>
          )}
        </Droppable>
      </DragDropContext>
    ) : null;
  }
}


// WEBPACK FOOTER //
// ./src/components/DraggableList/index.js